import { defineComponent, ref, onMounted, h } from '@vue/composition-api';
import { withInstall } from '../util';
import "../style/components/container.css";
export var ContainerProps = {
  // 背景图片地址
  backgroundImage: {
    type: String,
    "default": ''
  },
  // 图片样式
  imageStyle: {
    type: Object,
    "default": function _default() {
      return {};
    }
  },
  // 懒加载类型 background-image children or all
  lazyType: {
    type: String,
    "default": ''
  },
  // 懒加载 间隔耗时
  throttleWait: {
    type: Number,
    "default": 200
  }
};

var debounce = function debounce(fn) {
  var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
  var timer = null;
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (timer) clearTimeout(timer);
    timer = setTimeout(function () {
      fn.apply(void 0, args);
    }, delay);
  };
};

var Container = defineComponent({
  name: 'm-container',
  props: ContainerProps,
  setup: function setup(props, _ref) {
    var slots = _ref.slots,
        refs = _ref.refs; // 懒加载类型 当前仅支持background-image

    var lazyType = props.lazyType === 'background-image';
    var visible = ref(!lazyType);
    var updateVisible = debounce(function () {
      // 判断容器是否还存在
      if (!(refs !== null && refs !== void 0 && refs.container)) {
        return;
      }

      var viewHeight = window.innerHeight || document.documentElement.clientHeight;
      var distance = viewHeight - refs.container.getBoundingClientRect().top; // 如果可视区域高度大于等于元素顶部距离可视区域顶部的高度，说明元素露出

      if (distance >= 0) {
        visible.value = true;
        window.removeEventListener('scroll', updateVisible);
      }
    }, props.throttleWait);
    onMounted(function () {
      if (!visible.value) {
        // 添加监听事件
        window.addEventListener('scroll', updateVisible); // 展示当前视区内的资源

        updateVisible();
      }
    });
    return function () {
      var _slots$default;

      return h("div", {
        "class": "m-container",
        "ref": "container"
      }, [props.backgroundImage && visible.value ? h("img", {
        "class": "m-container__bg-image",
        "attrs": {
          "src": props.backgroundImage
        },
        "style": props.imageStyle
      }) : null, (_slots$default = slots["default"]) === null || _slots$default === void 0 ? void 0 : _slots$default.call(slots)]);
    };
  }
});
withInstall(Container);
export default Container;